const events = [
  {
    year: "2013",
    who: "早年 · 一次选秀后台",
    title: "一句玩笑被录进了带子",
    text: "旧视频里那句「今晚比不过，明年我们换个台再比」——当初没人在意，如今成了这段历史旧账最早的一截。",
  },
  {
    year: "2016",
    who: "早年言论 · 一场群访",
    title: "「我跟他，不熟」",
    text: "台上称兄道弟、台下把关系撇干净，两段早年言论摆在一起，缝就裂开了第一道口子。",
  },
  {
    year: "2019",
    who: "陈年往事 · 同台旧怨",
    title: "明面上的冷遇被拍下来",
    text: "颁奖礼后台错身而过、连正眼都没给，这段冷遇被多方镜头从不同角度同时拍到。",
  },
  {
    year: "2022",
    who: "黑历史后续 · 一句狠话",
    title: "旧访谈里那句狠话发酵",
    text: "十年前的话被考古发现重新搬上台面，当事人回复「不记得了」，留言区却把出处都翻了出来。",
  },
  {
    year: "2024",
    who: "考古发现 · 被删电台录音",
    title: "消失的半年被补回来",
    text: "一段删掉的电台录音找回，原来「和解又翻脸」中间还隔着一次没谈拢的通告与一部没接的戏。",
  },
  {
    year: "2026",
    who: "归档 · 本卷对账完成",
    title: "一页页摊开，脉络终于接上",
    text: "呱呱黑料把前后十三年的早年言论、陈年往事与黑历史后续逐条对账，拼出了这段旧账的完整模样。",
  },
];

export default function Timeline() {
  return (
    <section id="timeline" className="scroll-mt-4 border-y border-[#e3d7bd] bg-[#f3ead8]">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-2">
          <h4 className="flex items-center gap-2 text-[11px] tracking-[0.35em] text-[#852f12]">
            <i className="ri-time-line" aria-hidden="true"></i>
            呱呱黑料 · 考古时间线
          </h4>
          <h3 className="font-display mt-3 text-2xl font-black text-[#1a160e] md:text-4xl">
            一段历史旧账，按年份摊开
          </h3>
          <p className="mt-3 max-w-2xl text-sm leading-6 text-[#6f6552]">
            把早年言论、陈年往事与后续回应放在同一条轴上，你才能看出哪句是开头的狠话，
            哪句是中间埋的线，哪句是最后翻出的旧账。
          </p>
        </div>

        <ol className="relative mt-14 ml-3 border-l border-[#b1401f]/40 pl-6 md:ml-8 md:pl-10">
          {events.map((ev, i) => (
            <li key={ev.year} className="relative pb-12 last:pb-0">
              <span
                className="absolute top-1.5 -left-[29px] flex h-3.5 w-3.5 items-center justify-center rounded-full border-2 border-[#faf5eb] bg-[#b1401f] md:-left-[39px]"
                aria-hidden="true"
              ></span>
              <div className="flex flex-col gap-1.5 md:flex-row md:items-baseline md:gap-6">
                <span className="font-display text-2xl font-black text-[#b1401f] md:text-3xl">
                  {ev.year}
                </span>
                <div>
                  <p className="text-[11px] tracking-widest text-[#6f6552]">{ev.who}</p>
                  <h4 className="font-display mt-1 text-lg font-bold text-[#1a160e] md:text-xl">
                    {ev.title}
                  </h4>
                  <p className="mt-2 max-w-2xl text-sm leading-6 text-[#6f6552]">{ev.text}</p>
                </div>
              </div>
              {i === events.length - 1 ? null : (
                <span className="absolute left-0 top-0 hidden h-full w-px -translate-x-1/2 bg-[#e3d7bd] md:block" aria-hidden="true"></span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}